import { useEffect, useState } from "react";
import DateSelector from "../../../components/shared/fields/DateSelector";
import GridCard from "../../../components/shared/gridCard/GridCard";
import CaseDarkOrange from "../../../images/case_dark_orange.svg";
import CaseOrange from "../../../images/case_orange.svg";
import Button from "../../../components/shared/buttons/button";
import { Col, Row } from "react-bootstrap";
import InfoCard from "../../../components/shared/infocard/InfoCard";
import { PlusSvg } from "../../../svgFiles/PlusSvg";
import {
  useGetCheekStripPackedDataQuery,
  useGetPackingBandRecordQuery,
  useCreatePackingBandRecordMutation,
  useUpdatePackingBandRecordMutation,
  useGetPackingRecordSummaryQuery,
} from "./packingApi";
import NoDataFound from "../../../components/shared/noDataFound/NoDataFound";
import PackedDataModal from "./PackedDataModal";
import PackingBandModal from "./PackingBandModal";
import useTranslator from "../../../hooks/useTranslator";
import "./Packing.css";
import { formatDateAndTime, getCurrentDate, makePriorLotNumber } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";
  
const Packing = () => {
  const { _t } = useTranslator();
  const [page, setPage] = useState(1);  
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [addPackingData, setAddPackingData] = useState(false);
  const [addEmployeeData, setAddEmployeeData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("");
  const [lotNumber, setLotNumber] = useState(makePriorLotNumber(date));  

  const [stripPackedButton, setStripPackedButton] = useState(_t("add_data", "Add Data"));
  const [cheekPackedButton, setCheekPackedButton] = useState(_t("add_data", "Add Data"));
  
  // Packing Band states
  const [showDayBandModal, setShowDayBandModal] = useState(false);
  const [showNightBandModal, setShowNightBandModal] = useState(false);
  const [dayBandMode, setDayBandMode] = useState("add");
  const [nightBandMode, setNightBandMode] = useState("add");
  const [dayBandData, setDayBandData] = useState(null);
  const [nightBandData, setNightBandData] = useState(null);
  
  
  const { data: packedData, isLoading } = useGetCheekStripPackedDataQuery(
    { 
      date,
      lot_number : lotNumber
    },
    { refetchOnMountOrArgChange: true }
  );

  const { data: summaryData } = useGetPackingRecordSummaryQuery(
    {
      tab: "dashboard",
      date,
      lot_number : lotNumber
    },
    { refetchOnMountOrArgChange: true }
  );
  
  const { data: dayBandRecordData } = useGetPackingBandRecordQuery({ date, shift: "day" ,lot_number : lotNumber ,data_from: "packing" });
  const { data: nightBandRecordData } = useGetPackingBandRecordQuery({ date, shift: "night" ,lot_number : lotNumber , data_from: "packing" });
  const [createPackingBandRecord] = useCreatePackingBandRecordMutation();
  const [updatePackingBandRecord] = useUpdatePackingBandRecordMutation();

  const handleCheeksPacked = () => {
    setAddPackingData(true);
    setModalMode("cheeks");
    setSelectedRecord(null);

    if (packedData !== null && packedData.data.data.length !== 0) {
      const cheeksRecord = packedData.data.data.find(
        (item) => item.type === "cheeks"
      );
      if (cheeksRecord) {
        setModalMode("editCheeks");
        setSelectedRecord(cheeksRecord);
      }
    }
    setShowModal(true);
  };
  const handleStripsPacked = () => {
    setAddPackingData(true);
    setModalMode("strips");
    setSelectedRecord(null);
    if (packedData !== null && packedData.data.data.length !== 0) {
      const stripsRecord = packedData.data.data.find(
        (item) => item.type === "strips"
      );
      if (stripsRecord) {
        setModalMode("editStrips");
        setSelectedRecord(stripsRecord);
      }
    }
    setShowModal(true);
  };

  useEffect(() => {
    const items = packedData?.data?.data;
    if (Array.isArray(items) && items.length > 0) {
      const cheeksRecord = items.find((item) => item.type === "cheeks");
      const stripsRecord = items.find((item) => item.type === "strips");

      if (cheeksRecord) {
        setCheekPackedButton(_t("edit_data", "Edit Data"));
      }

      if (stripsRecord) {
        setStripPackedButton(_t("edit_data", "Edit Data"));
      }
    } else {
      setCheekPackedButton(_t("add_data", "Add Data"));
      setStripPackedButton(_t("add_data", "Add Data"));
    }
  }, [packedData, _t]);

 

  const cheeksBoxesPackedData = packedData?.data?.data
    .filter((item) => item.type === "cheeks")
    .map((item) => [
      {
        label: _t("cheeks_packed_before_lunch", "Cheeks Packed Before Lunch"),
        value: `${item.packed_before_lunch_type_one || 0}`,
        subvalue: `(10 ${_t('pound' ,'Pounds')})`,
      },
      {
        label: _t("cheeks_packed_after_lunch", "Cheeks Packed After Lunch"),
        value: `${item.packed_after_lunch_type_one || 0}`,
        subvalue: `(10 ${_t('pound' ,'Pounds')})`,
      },
      {
        label: _t("cheeks_packed_before_lunch", "Cheeks Packed Before Lunch"),
        value: `${item.packed_before_lunch_type_two || 0}`,
        subvalue: `(20 ${_t('pound' ,'Pounds')})`,
      },
      {
        label: _t("cheeks_packed_after_lunch", "Cheeks Packed After Lunch"),
        value: `${item.packed_after_lunch_type_two || 0}`,
        subvalue: `(20 ${_t('pound' ,'Pounds')})`,
      },
      {
        label: _t("total_cheek_boxes_packed", "Total Cheek Boxes Packed"),
        value: item.boxes_packed,
      },
      {
        label: _t("total_cheek_pallets_ready", "Total Cheek Pallets Ready"),
        value: item.pallets,
      },
    ]);

  const stripsBoxesPackedData = packedData?.data?.data
    .filter((item) => item.type === "strips")
    .map((item) => [
 
      {
        label: _t("strips_packed_before_lunch", "Strips Packed Before Lunch"),
        value: `${item.packed_before_lunch_type_two || 0}`,
        subvalue: `(20 ${_t('pound' ,'Pounds')})`,
      },

      {
        label: _t("strips_packed_after_lunch", "Strips Packed After Lunch"),
        value: `${item.packed_after_lunch_type_two || 0}`,
        subvalue: `(20 ${_t('pound' ,'Pounds')})`,
      },
      {
        label: _t("total_strip_boxes_packed", "Total Strip Boxes Packed"),
        value: item.boxes_packed,
      },
      {
        label: _t("total_strip_pallets_ready", "Total Strip Pallets Ready"),
        value: item.pallets,
      },
    ]);


  const listItems = [
    {
      label: _t("total_prime_cheeks_entered", "Total Prime Cheeks entered"),
      value: `${summaryData?.data.total_prime_cheeks_entered ?? 0} KG`,
      icon: CaseOrange,
    },
    {
      label: _t("total_prime_strips_entered", "Total Prime Strips Entered"),
      value: `${summaryData?.data.total_prime_strips_entered ?? 0} KG`,
      icon: CaseDarkOrange,
    },
    {
      label: _t("cheeks_boxes_packed_10lb", "Cheek Boxes Packed(10lb)"),
      value: summaryData?.data.total_cheeks_boxes_packed_10_lb ?? 0,
      icon: CaseOrange,
    },
    {
      label: _t("cheeks_boxes_packed_20lb", "Cheek Boxes Packed(20lb)"),
      value: summaryData?.data.total_cheeks_boxes_packed_20_lb ?? 0,
      icon: CaseOrange,
    },
    {
      label: _t("strips_boxes_packed_20lb", "Strip Boxes Packed(20lb)"),
      value: summaryData?.data.total_strips_boxes_packed_20_lb ?? 0,
      icon: CaseDarkOrange,
    },
  ];

  const handleEdit = (data) => {
    setAddEmployeeData(true);
    setModalMode("edit");
    setSelectedRecord(data);
    setShowModal(true);
  };

  useEffect(() => {
    setLotNumber(makePriorLotNumber(date));    
  }, [date]);

  useEffect(() => {
    const record = dayBandRecordData?.data;
    setDayBandData(record?.id ? record : null);
  }, [dayBandRecordData]);

  useEffect(() => {
    const record = nightBandRecordData?.data;
    setNightBandData(record?.id ? record : null);
  }, [nightBandRecordData]);

  const handleDayBandAdd = () => {
    setShowDayBandModal(true);
    setDayBandMode(dayBandData?.id ? "edit" : "add");
  };

  const handleNightBandAdd = () => {
    setShowNightBandModal(true);
    setNightBandMode(nightBandData?.id ? "edit" : "add");
  };

  const handleDayBandSave = async (data) => {
    try {
      const payload = { ...data, data_from: "packing" };
      if (dayBandData && dayBandData.id) {
        await updatePackingBandRecord({ id: dayBandData.id, requestBody: payload }).unwrap();
      } else {
        await createPackingBandRecord(payload).unwrap();
      }
    } catch (error) {
      console.error("Error saving day band data:", error);
    }
  };

  const handleNightBandSave = async (data) => {
    try {
      const payload = { ...data, data_from: "packing" };
      if (nightBandData && nightBandData.id) {
        await updatePackingBandRecord({ id: nightBandData.id, requestBody: payload }).unwrap();
      } else {
        await createPackingBandRecord(payload).unwrap();
      }
    } catch (error) {
      console.error("Error saving night band data:", error);
    }
  };

  const dayBandLogData = dayBandData?.id
    ? [
        [
          { label: _t("band", "Band") + " 1", value: dayBandData.band_1_20lb || 0, subvalue: `(20 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 1", value: dayBandData.band_1_10lb || 0, subvalue: `(10 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 1", value: dayBandData.band_1_people || 0, subvalue: "(" + _t("people", "People") + ")" },
        ],
        [
          { label: _t("band", "Band") + " 2", value: dayBandData.band_2_20lb || 0, subvalue: `(20 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 2", value: dayBandData.band_2_10lb || 0, subvalue: `(10 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 2", value: dayBandData.band_2_people || 0, subvalue: "(" + _t("people", "People") + ")" },
        ],
        [
          { label: _t("band", "Band") + " 3", value: dayBandData.band_3_20lb || 0, subvalue: `(20 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 3", value: dayBandData.band_3_10lb || 0, subvalue: `(10 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 3", value: dayBandData.band_3_people || 0, subvalue: "(" + _t("people", "People") + ")" },
        ],
        [
          { label: _t("band", "Band") + " 4", value: dayBandData.band_4_20lb || 0, subvalue: `(20 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 4", value: dayBandData.band_4_10lb || 0, subvalue: `(10 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 4", value: dayBandData.band_4_people || 0, subvalue: "(" + _t("people", "People") + ")" },
        ],
        [
          { label: _t("band", "Band") + " 5", value: dayBandData.band_5_20lb || 0, subvalue: `(20 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 5", value: dayBandData.band_5_10lb || 0, subvalue: `(10 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 5", value: dayBandData.band_5_people || 0, subvalue: "(" + _t("people", "People") + ")" },
        ],
      ]
    : [];

  const nightBandLogData = nightBandData?.id
    ? [
        [
          { label: _t("band", "Band") + " 1", value: nightBandData.band_1_20lb || 0, subvalue: `(20 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 1", value: nightBandData.band_1_10lb || 0, subvalue: `(10 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 1", value: nightBandData.band_1_people || 0, subvalue: "(" + _t("people", "People") + ")" },
        ],
        [
          { label: _t("band", "Band") + " 2", value: nightBandData.band_2_20lb || 0, subvalue: `(20 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 2", value: nightBandData.band_2_10lb || 0, subvalue: `(10 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 2", value: nightBandData.band_2_people || 0, subvalue: "(" + _t("people", "People") + ")" },
        ],
        [
          { label: _t("band", "Band") + " 3", value: nightBandData.band_3_20lb || 0, subvalue: `(20 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 3", value: nightBandData.band_3_10lb || 0, subvalue: `(10 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 3", value: nightBandData.band_3_people || 0, subvalue: "(" + _t("people", "People") + ")" },
        ],
        [
          { label: _t("band", "Band") + " 4", value: nightBandData.band_4_20lb || 0, subvalue: `(20 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 4", value: nightBandData.band_4_10lb || 0, subvalue: `(10 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 4", value: nightBandData.band_4_people || 0, subvalue: "(" + _t("people", "People") + ")" },
        ],
        [
          { label: _t("band", "Band") + " 5", value: nightBandData.band_5_20lb || 0, subvalue: `(20 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 5", value: nightBandData.band_5_10lb || 0, subvalue: `(10 ${_t('pound', 'Pound')})` },
          { label: _t("band", "Band") + " 5", value: nightBandData.band_5_people || 0, subvalue: "(" + _t("people", "People") + ")" },
        ],
      ]
    : [];

    // console.log(`nightBandData : ${nightBandData} || dayBandData : ${dayBandData}`);
  const isToday = date === currentDate;
  const hasDayBandRecord = Boolean(dayBandData?.id);
  const hasNightBandRecord = Boolean(nightBandData?.id);


  return (
    <div>
      {addPackingData && (
        <PackedDataModal
          show={showModal}
          setShow={setAddPackingData}
          mode={modalMode}
          record={selectedRecord}
          lot_number_id={lotNumber}
        />
      )}

      <PackingBandModal
        show={showDayBandModal}
        setShow={setShowDayBandModal}
        record={hasDayBandRecord ? dayBandData : null}
        mode={dayBandMode}
        onSave={handleDayBandSave}
        date={date}
        lotNumber={lotNumber}
        shift="day"
      />

      <PackingBandModal
        show={showNightBandModal}
        setShow={setShowNightBandModal}
        record={hasNightBandRecord ? nightBandData : null}
        mode={nightBandMode}
        onSave={handleNightBandSave}
        date={date}
        lotNumber={lotNumber}
        shift="night"
      />
    
      <div className="overview cmn_card">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">{_t("overview", "Overview")}</h6>
          <div className="d-flex gap-2 align-items-center">
            <h6 className="mb-0">{_t("packing_batch_code", "Packing Batch Code")}</h6>
            <Button
              // onClick={AddEmployee}
              label={`#${lotNumber}`}
              size="small"
              className="borderRedBtn"
            />
            <DateSelector setDate={setDate}  />
          </div>
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") : formatDateAndTime(date, PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>
      </div>
    
      <div className="my-3">
        <h6 className="mb-3">{_t("packed_boxes_log", "Packed Boxes Log")}</h6>
        <div className="gap-2  overviewcard">
          <Row>
            <Col lg={6}>
              <div className="dash_card h-100">
                <div className="d-flex justify-content-between align-items-center dash_header">
                  <div className="packing-card-header-content">
                    <h3 className="mb-0 packing-card-title">
                      {_t("cheeks_boxes_packed", "Cheeks Boxes Packed")}
                    </h3>
                    <span className="shift-badge packing-lot-badge">{`${_t('lot_no', 'Lot No.')} #${lotNumber}`}</span>
                  </div>
                  {!isLoading && (date === currentDate || !packedData?.data?.data?.find((item) => item.type === "cheeks")) && (
                    <Button
                      size="xs"
                      label={cheekPackedButton}
                      icon={PlusSvg}
                      onClick={handleCheeksPacked}
                    />
                  )}
                </div>
                <div className="p-3">
                  <Row>
                    {cheeksBoxesPackedData?.length > 0 ? (
                      cheeksBoxesPackedData.map((data, index) => (
                        <Row key={index}>
                          {data.map((item) => (
                            <Col lg={6} key={item.label}>
                              <InfoCard
                                label={item.label}
                                value={item.value}
                                subvalue={item?.subvalue ?? ""}
                              />
                            </Col>
                          ))}
                        </Row>
                      ))
                    ) : (
                      <NoDataFound />
                    )}
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className="dash_card h-100">
                <div className="d-flex justify-content-between align-items-center dash_header">
                  <div className="packing-card-header-content">
                    <h3 className="mb-0 packing-card-title">
                      {_t("strips_boxes_packed", "Strips Boxes Packed")}
                    </h3>
                    <span className="shift-badge packing-lot-badge">{`${_t('lot_no', 'Lot No.')} #${lotNumber}`}</span>
                  </div>
                  {!isLoading && (date === currentDate || !packedData?.data?.data?.find((item) => item.type === "strips")) && (
                  <Button
                    size="xs"
                    label={stripPackedButton}
                    icon={PlusSvg}
                    onClick={handleStripsPacked}
                  />
                  )}
                </div>
                <div className="p-3">
                  <Row>
                    {stripsBoxesPackedData?.length > 0 ? (
                      stripsBoxesPackedData.map((data, index) => (
                        <Row key={index}>
                          {data.map((item) => (
                            <Col lg={6} key={item.label}>
                              <InfoCard
                                label={item.label}
                                value={item.value}
                                subvalue={item?.subvalue ?? ""}
                              />
                            </Col>
                          ))}
                        </Row>
                      ))
                    ) : (
                      <NoDataFound />
                    )}
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      <div className="packing-band-log-section">
        <h6 className="packing-band-log-title">{_t("packing_band_log", "Packing Band Log")}</h6>
        <div className="gap-2 overviewcard">
          <Row>
            <Col lg={6}>
              <div className="band-card-container">
                <div className="band-card-header">
                  <div className="packing-card-header-content">
                    <h3 className="band-card-title">
                      {_t("day_shift", "Day Shift")}
                    </h3>
                    <span className="shift-badge packing-lot-badge">{`${_t('lot_no', 'Lot No.')} #${lotNumber}`}</span>
                  </div>
                  {(isToday || !hasDayBandRecord) && (
                    <Button
                      size="xs"
                      label={hasDayBandRecord ? _t("edit_data", "Edit") : _t("add_data", "Add")}
                      icon={PlusSvg}
                      onClick={handleDayBandAdd}
                      className="band-header-button"
                    />
                  )}
                </div>
                <div className="band-card-body">
                  {dayBandLogData.length > 0 ? (
                    <>
                      {dayBandLogData.map((data, index) => (
                        <div key={index} className="mb-2">
                          <div className="band-info-grid">
                            {data.map((item, itemIndex) => (
                              <div key={`${index}-${itemIndex}`} className="band-info-item">
                                <span className="band-info-label">{item.label}</span>
                                <span className="band-info-value">{item.value}</span>
                                {item.subvalue && (
                                  <span className="band-info-subvalue">{item.subvalue}</span>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <NoDataFound />
                  )}
                </div>
              </div>
            </Col>
            {/* <Col lg={6}>
              <div className="band-card-container">
                <div className="band-card-header">
                  <div className="packing-card-header-content">
                    <h3 className="band-card-title">
                      {_t("night_shift", "Night Shift")}
                    </h3>
                    <span className="shift-badge packing-lot-badge">{`${_t('lot_no', 'Lot No.')} #${lotNumber}`}</span>
                  </div>
                  {(isToday || !hasNightBandRecord) && (
                    <Button
                      size="xs"
                      label={hasNightBandRecord ? _t("edit_data", "Edit") : _t("add_data", "Add")}
                      icon={PlusSvg}
                      onClick={handleNightBandAdd}
                      className="band-header-button"
                    />
                  )}
                </div>
                <div className="band-card-body">
                  {nightBandLogData.length > 0 ? (
                    <>
                      {nightBandLogData.map((data, index) => (
                        <div key={index} className="mb-2">
                          <div className="band-info-grid">
                            {data.map((item, itemIndex) => (
                              <div key={`${index}-${itemIndex}`} className="band-info-item">
                                <span className="band-info-label">{item.label}</span>
                                <span className="band-info-value">{item.value}</span>
                                {item.subvalue && (
                                  <span className="band-info-subvalue">{item.subvalue}</span>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <NoDataFound />
                  )}
                </div>
              </div>
            </Col> */}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Packing;
